import { Helmet } from 'react-helmet-async';

export default function SEO({ 
  title, 
  description, 
  keywords, 
  canonicalUrl,
  ogType = "website",
  ogImage = "https://wprescate24.com/og-image.jpg",
  robots = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  structuredData = null
}) {
  const siteTitle = "WPRescate24 - Expertos en WordPress";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "WPRescate24",
    "description": "Agencia especializada en rescate, optimización, mantenimiento y seguridad de sitios WordPress",
    "url": "https://wprescate24.com",
    "telephone": "+52-722-381-8617",
    "email": "ventas@wprescate24.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "MX",
      "addressLocality": "Toluca",
      "addressRegion": "Estado de México"
    },
    "sameAs": [
      "https://garey.mx"
    ],
    "priceRange": "$$",
    "image": ogImage,
    "founder": {
      "@type": "Organization",
      "name": "GAREY AW",
      "url": "https://garey.mx"
    }
  };
  const additionalSchemas = Array.isArray(structuredData)
    ? structuredData.filter(Boolean)
    : structuredData
      ? [structuredData]
      : [];
  const schemas = [localBusinessSchema, ...additionalSchemas];
  
  return (
    <Helmet>
      {/* Meta Tags Básicos */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="WPRescate24" />
      <meta property="og:locale" content="es_MX" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      {canonicalUrl && <meta property="twitter:url" content={canonicalUrl} />}
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      <meta property="twitter:site" content="@wprescate24" />
      
      {/* Robots */}
      <meta name="robots" content={robots} />
      
      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      
      {/* Language */}
      <html lang="es-MX" />
      
      {/* Schema.org JSON-LD */}
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
